__turbopack_context__.v({
  "base": "Hero-module-scss-module__VO45_W__base",
  "cutout": "Hero-module-scss-module__VO45_W__cutout",
  "hero": "Hero-module-scss-module__VO45_W__hero",
  "hero-drift": "Hero-module-scss-module__VO45_W__hero-drift",
  "hero-title-drift": "Hero-module-scss-module__VO45_W__hero-title-drift",
  "layer": "Hero-module-scss-module__VO45_W__layer",
  "layerA": "Hero-module-scss-module__VO45_W__layerA",
  "layerB": "Hero-module-scss-module__VO45_W__layerB",
  "layerFill": "Hero-module-scss-module__VO45_W__layerFill",
  "playerSlot": "Hero-module-scss-module__VO45_W__playerSlot",
  "title": "Hero-module-scss-module__VO45_W__title",
  "vignette": "Hero-module-scss-module__VO45_W__vignette",
  "wheatFar": "Hero-module-scss-module__VO45_W__wheatFar",
  "wheatNear": "Hero-module-scss-module__VO45_W__wheatNear",
});
